<template>
    <v-layout
    class='footerbg'
          row
          wrap
          align-center
        >
          <v-flex xs12>
             
          
            <v-container>
              <v-row height='1500px'
                align="end"
                class=" white--text fill-height"
              >
  <v-col v-if='!$vuetify.breakpoint.xsOnly'
        md="5"
      >
           <img
                      style='width: 350px'
                      src="../../assets/staticAsset/footer_logo.png"
                    />
                  
                </v-col>
                <v-col md="5">
                  <div class="mb-3 subheading">
                    <h3 >A Project by Genetic Support Foundation</h3>
                    </div>
                </v-col>
                <v-col md="2">
                  <div class="mb-3 subheading">
                    <v-icon color='white' size='50' @click='linkTo("https://www.facebook.com/geneticsupportfoundation/")'>mdi-facebook</v-icon>
                    <v-icon color='white'  @click="linkTo('https://twitter.com/geneticsupport?lang=en')" size='50'>mdi-twitter</v-icon>
                    </div>
                </v-col>

              </v-row>
               </v-container>
           
            
          </v-flex>
        </v-layout>
</template>

<script>
export default {
  methods : {
    linkTo(website){
      window.open(website);
    }
  }
}
</script>

<style>
.footerbg {
  background-image: url("../../assets/staticAsset/footer-bg-green.png");
  background-position: center; /* Center the image */
  background-size: 2484px 300px;
}
</style>